import { render, staticRenderFns } from "./pointsgetlog-add-or-update.vue?vue&type=template&id=512b3291&"
import script from "./pointsgetlog-add-or-update.vue?vue&type=script&lang=js&"
export * from "./pointsgetlog-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports